import { FavoriteButton, useCompare } from '@iheartjane/menu';

import { CompareDot } from './compareDot';

interface ProductCardImageActionProps {
  compareEnabled: boolean;
  favoritesEnabled: boolean;
  focusCardMenu: () => void;
  isFavorite: boolean;
  onCompareToggle: () => void;
  onFavoriteToggle: () => void;
  productId: number;
  productName: string;
}

export const ProductCardImageAction = ({
  compareEnabled,
  favoritesEnabled,
  focusCardMenu,
  isFavorite,
  onCompareToggle,
  onFavoriteToggle,
  productId,
  productName,
}: ProductCardImageActionProps) => {
  const { isActive, isSelected } = useCompare();

  if (compareEnabled && (isActive || isSelected(productId))) {
    return (
      <CompareDot
        focusCardMenu={focusCardMenu}
        onToggle={onCompareToggle}
        productId={productId}
        productName={productName}
      />
    );
  }

  if (favoritesEnabled) {
    return (
      <FavoriteButton
        isFavorite={isFavorite}
        onToggle={onFavoriteToggle}
        productName={productName}
      />
    );
  }

  return null;
};
